import type { DbMinimaxVoice } from '@/api/astraea';
import { groupVoicesByGender } from '@/lib/voiceGroups';

interface MinimaxVoiceListProps {
  voices: DbMinimaxVoice[];
  selectedId: string;
  onSelect: (voiceId: string) => void;
  /** 只显示某一性别(建角色时用);不传则女声/男声分区都显示 */
  genderFilter?: 'female' | 'male';
}

function VoiceRow({ v, selected, onSelect }: { v: DbMinimaxVoice; selected: boolean; onSelect: () => void }) {
  return (
    <button type="button" onClick={onSelect}
      className={`w-full flex items-center justify-between gap-2 px-3 py-2.5 text-left cursor-pointer ${selected ? 'bg-primary-50' : 'hover:bg-background-100'}`}>
      <span className="flex items-center gap-2 min-w-0">
        <span className="text-sm text-foreground-800 truncate">{v.name || v.voice_id}</span>
        {v.tags && v.tags.length > 0 && (
          <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-secondary-100 text-secondary-500 whitespace-nowrap">{v.tags.join('·')}</span>
        )}
      </span>
      {selected && <i className="ri-check-line text-primary-500 flex-shrink-0"></i>}
    </button>
  );
}

function Section({ title, voices, selectedId, onSelect }: { title: string; voices: DbMinimaxVoice[]; selectedId: string; onSelect: (id: string) => void }) {
  if (!voices.length) return null;
  return (
    <div>
      <div className="sticky top-0 z-[1] px-3 py-2 text-xs font-semibold text-foreground-700 bg-secondary-50 border-b border-secondary-100">{title}</div>
      {voices.map((v) => (
        <VoiceRow key={v.voice_id} v={v} selected={selectedId === v.voice_id} onSelect={() => onSelect(v.voice_id)} />
      ))}
    </div>
  );
}

/** 手机友善：女声/男声分区列表(建角色、角色板绑定) */
export default function MinimaxVoiceList({ voices, selectedId, onSelect, genderFilter }: MinimaxVoiceListProps) {
  const { female, male, other } = groupVoicesByGender(voices);
  const showFemale = genderFilter ? genderFilter === 'female' : true;
  const showMale = genderFilter ? genderFilter === 'male' : true;

  return (
    <div className="max-h-52 overflow-y-auto rounded-lg border border-secondary-200 divide-y divide-secondary-100 bg-background-50">
      {showFemale && <Section title={`女声 (${female.length})`} voices={female} selectedId={selectedId} onSelect={onSelect} />}
      {showMale && <Section title={`男声 (${male.length})`} voices={male} selectedId={selectedId} onSelect={onSelect} />}
      {!genderFilter && other.length > 0 && <Section title={`其他 (${other.length})`} voices={other} selectedId={selectedId} onSelect={onSelect} />}
    </div>
  );
}
